import { Box, Stack, Typography } from '@mui/material'

export default function Property({ label, value }: { label: string; value: string | number }) {
	return (
		<Stack direction="row">
			<Box width="12rem">
				<Typography variant="body2">
					<b>{label}</b>
				</Typography>
			</Box>
			<Typography variant="body2">{value}</Typography>
		</Stack>
	)
}
